import { render, staticRenderFns } from "./RecipeBrowser.vue?vue&type=template&id=b9c71c42&scoped=true&"
import script from "./RecipeBrowser.vue?vue&type=script&lang=js&"
export * from "./RecipeBrowser.vue?vue&type=script&lang=js&"
import style0 from "./RecipeBrowser.vue?vue&type=style&index=0&id=b9c71c42&scoped=true&lang=css&"
import style1 from "./RecipeBrowser.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c71c42",
  null
  
)

export default component.exports